export const CSS_FIXED_CELL_WIDTH = '200px';
export const CSS_PHASE_CELL_MIN_WIDTH = '115px';
export const CSS_LAST_COLUMN_FLEX = '4';
export const CSS_CELL_PADDING_SUMMARY = '5px';
export const CSS_NUMBER_COLUMN_WIDTH = '30px';
